// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"MainLayout_navContainer__1bGXF"};